import { useState } from 'react';

interface StageChannels {
  websiteSale: boolean;
  appSale: boolean;
  posSale: boolean;
  door: boolean;
  linkSale: boolean;
}

/**
 * The five sale-channel toggles of a stage with Go's rules applied as the admin
 * flips them: Link is exclusive (on clears the other four, any other on clears
 * Link), and Website needs App (Website on turns App on, App off turns Website off).
 */
export function useStageChannels(stage: StageChannels) {
  const [channels, setChannels] = useState<StageChannels>({
    websiteSale: stage.websiteSale,
    appSale: stage.appSale,
    posSale: stage.posSale,
    door: stage.door,
    linkSale: stage.linkSale,
  });

  const setLink = (on: boolean) =>
    setChannels(
      on
        ? { websiteSale: false, appSale: false, posSale: false, door: false, linkSale: true }
        : { ...channels, linkSale: false },
    );
  const setWebsite = (on: boolean) =>
    setChannels(
      on
        ? { ...channels, websiteSale: true, appSale: true, linkSale: false }
        : { ...channels, websiteSale: false },
    );
  const setApp = (on: boolean) =>
    setChannels(
      on
        ? { ...channels, appSale: true, linkSale: false }
        : { ...channels, appSale: false, websiteSale: false },
    );
  const setPos = (on: boolean) =>
    setChannels({ ...channels, posSale: on, linkSale: on ? false : channels.linkSale });
  const setDoor = (on: boolean) =>
    setChannels({ ...channels, door: on, linkSale: on ? false : channels.linkSale });

  return { channels, setLink, setWebsite, setApp, setPos, setDoor };
}
